export default "__VITE_ASSET__f6cac731__"